import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTASection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 px-4 bg-brand-green text-center" data-id="element-55">
      <div className="max-w-3xl mx-auto" data-id="element-56">
        <h2 className="text-3xl md:text-5xl font-black text-white mb-10 font-serif" data-id="element-57">
          Pronta a riprenderti il tuo tempo?
        </h2>
        <CTAButton variant="terracotta" onClick={scrollToPricing} className="text-lg py-5 px-10" data-id="element-58">
          SÌ, VOGLIO YOGA PRONTA
        </CTAButton>
      </div>
    </section>;
}